module.exports = __webpack_public_path__ + "img/4-2.0af64852.svg";